import React from "react";

import { Dropdown, Tooltip } from "antd";

import { ReactComponent as PlusIcon } from "../../../../assets/images/sample-submission/addSamplePlusIcon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/sample-submission/edit.svg";
import { ReactComponent as GarbageCan } from "../../../../assets/images/sample-submission/hoveredGarbageCan.svg";
import { ReactComponent as MoreIcon } from "../../../../assets/images/sample-submission/moreIcon.svg";

import { designTokens } from "../../../../styles/tokens";
import "./ActionsMenu.css";

const RETEST_SAMPLE_DISABLED_TOOLTIP = "Cannot edit Retest Sample";
const RETEST_SUBMISSION_DISABLED_TOOLTIP = "Cannot edit Retest Submission";

export default function ActionsMenu({
  handleEdit,
  handleDelete,
  handleAdd,
  disableAdd,
  disableAddRetest,
  disableDelete,
  disableEditRetest,
  disableEditRetestSubmission,
  disabled,
  disabledTooltipText,
}) {
  const items = [];
  const isAddDisabled = disableAdd || disableAddRetest;
  const isEditDisabled = disableEditRetest || disableEditRetestSubmission;
  const addDisabledTooltip = disableAddRetest
    ? RETEST_SUBMISSION_DISABLED_TOOLTIP
    : "Cannot add samples after Samples Received";
  const editDisabledTooltip = disableEditRetestSubmission
    ? RETEST_SUBMISSION_DISABLED_TOOLTIP
    : RETEST_SAMPLE_DISABLED_TOOLTIP;

  if (handleEdit) {
    items.push({
      label:
  <Tooltip
    title={isEditDisabled ? editDisabledTooltip : ""}
    overlayClassName="SampleSubmission__ActionsMenu__Tooltip"
  >
    <div
      className={`SampleSubmission__ActionsMenuItem ${isEditDisabled ? "SampleSubmission__ActionsMenuItem--disabled" : ""}`}
      onClick={isEditDisabled ? null : handleEdit}
    >
      <EditIcon className="SampleSubmission__ActionsMenuEditIcon" />
      <span>Edit</span>
    </div>
  </Tooltip>,
      key: "0",
      disabled: isEditDisabled ?? false,
    });
  }

  if (handleAdd) {
    items.push({
      label:
  <Tooltip
    title={isAddDisabled ? addDisabledTooltip : ""}
    overlayClassName="SampleSubmission__ActionsMenu__Tooltip"
  >
    <div
      className={`SampleSubmission__ActionsMenuItem--add ${isAddDisabled ? "SampleSubmission__ActionsMenuItem--disabled" : ""}`}
      onClick={isAddDisabled ? null : handleAdd}
    >
      <PlusIcon
        className="SampleSubmission__ActionsMenuAddIcon"
        width={18}
        height={18}
      />
      <span>Add Samples</span>
    </div>
  </Tooltip>,
      key: "2",
      disabled: isAddDisabled ?? false,
    });
  }

  if (handleDelete) {
    items.push({
      label:
  <Tooltip
    title={disableDelete ? "Cannot delete samples after Samples Received" : ""}
    overlayClassName="SampleSubmission__ActionsMenu__Tooltip"
    placement="right"
  >
    <div
      className={`SampleSubmission__ActionsMenuItem ${disableDelete ? "SampleSubmission__ActionsMenuItem--disabled" : ""}`}
      onClick={disableDelete ? null : handleDelete}
    >
      <GarbageCan className="SampleSubmission__ActionsMenuDeleteIcon" />
      <span>Delete</span>
    </div>
  </Tooltip>,
      key: "1",
      disabled: disableDelete ?? false,
    });
  }

  return (
    <Tooltip
      title={disabled ? disabledTooltipText ?? "" : ""}
      placement="right"
      overlayClassName="SampleSubmission__ActionsMenu__Tooltip"
    >
      <Dropdown
        menu={{ items }}
        disabled={disabled ?? false}
        trigger={["click"]}
        overlayClassName="SampleSubmission__ActionsMenu"
      >
        <MoreIcon
          className={`SampleSubmission__ActionsMenuMoreIcon${disabled ? "--disabled" : ""}`}
          fill={disabled ? designTokens.colorBorderSecondary : designTokens.colorContentBase}
          width={20}
          height={20}
        />
      </Dropdown>
    </Tooltip>

  );
}
